import { Accordion, AccordionDetails, AccordionSummary, Stack } from '@mui/material';
import { WrapFormElementProps } from './index';
import { getFromComponentPropsClass } from 'components/common/form/layout/control';
import useBundleTranslation from 'i18n';
import React, { useState } from 'react';
import { prepareFormElementProps } from 'components/common/form/formTools';
import { RawFormComponentType } from 'components/common/form';
import FormStaticLabel from 'components/common/form/layout/static/FormStaticLabel';

export default function FormWrapperCollapsible({ elementProps, children, componentValues }: WrapFormElementProps) {
    const { t } = useBundleTranslation([elementProps.translationNS ?? 'main']);
    const className = 'form-wrapper-collapsible ' + getFromComponentPropsClass(elementProps, componentValues);
    const label = elementProps.componentProps.translate
        ? t(elementProps.componentProps.label as string)
        : elementProps.componentProps.label;

    const [expanded, setExpanded] = useState(false);

    return (
        <Accordion
            className={className}
            disableGutters
            elevation={0}
            square
            sx={{ border: 'none' }}
            expanded={expanded}
            onChange={(event: any, newExpanded: boolean) => setExpanded(newExpanded)}
        >
            <AccordionSummary
                sx={{
                    padding: 0,
                    '& .MuiAccordionSummary-content': {
                        width: '100%',
                        display: 'inline-block',
                        margin: 0,
                        '&.Mui-expanded': {
                            margin: 0,
                        },
                    },
                }}
            >
                <FormStaticLabel
                    elementProps={prepareFormElementProps({
                        form: elementProps.form,
                        component: {
                            label: label,
                            props: {
                                isSectionLabel: true,
                                icon: expanded ? 'chevron-down' : 'chevron-right',
                            },
                        } as RawFormComponentType,
                    })}
                />
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0 }}>
                <Stack spacing={2}>{children}</Stack>
            </AccordionDetails>
        </Accordion>
    );
}
